exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Icon___2CecY {\n  width: 1rem;\n  height: 1rem;\n  fill: currentColor;\n}\n", ""]);

// exports
exports.locals = {
	"Icon": "Icon___2CecY"
};